const links = {
  Incidents: '/incidents',
  'Recent Changes': '/change-events',
  Alerts: '/alerts',
  'My On-Call Shifts': '/my-on-call',
  'Escalation Policies': '/escalation_policies',
  Schedules: '/schedules',
  'On-Call Schedules': '/schedules',
  'Service Directory': '/service-directory',
  Services: '/service-directory',
  'Service Intelligence': '/service_intelligence',
  'Event Intelligence': '/event_intelligence',
  'Event Rules': '/rules/rulesets',
  'Response Plays': '/response_plays',
  'Business Services': '/business-services',
  'Impact Metrics': '/business_impact_metrics',
  Users: '/users',
  Teams: '/teams',
  'License Administration': '/admin-dashboard/license-administration',
  'Operations Health': '/ohms',
  'PD Labs': '/analytics/labs',
  'Operational Reviews': '/analytics/operational-reviews',
  'Intelligent Dashboards': '/analytics/dashboards',
  'Notification Volume': '/reports#notification',
  'Incident Volume': '/reports#incidents',
  'System Report': '/reports#system',
  'Team Report': '/reports#team',
  'User Report': '/reports#user',
  'System Report (Preview)': '/preview/system-report',
  'Team Report (Preview)': '/preview/team-report',
  'User Report (Preview)': '/preview/user-report',
  Postmortems: '/postmortems',
  'Postmortems (Preview)': '/preview/postmortems',
  Visibility: '/visibility',
  Status: '/status-dashboard',
  Extensions: '/extensions',
  'Add On Settings': '/extensions/add_ons',
  'Integrations Guides': 'https://www.pagerduty.com/integrations',
  'App Directory': 'https://www.pagerduty.com/integrations',
  'Integrations Directory': 'https://www.pagerduty.com/integrations',
  'Developer Mode': '/developer/apps',
  'API Access': '/api_keys',
  'Account Settings': '/account/settings',
  Logout: '/sign_out',
  'Knowledge Base': 'https://support.pagerduty.com/docs',
  'Community Discussions': 'https://community.pagerduty.com',
  'Contact Support': 'https://support.pagerduty.com/hc/en-us/requests/new',
  Help: 'https://support.pagerduty.com/hc/en-us/sections/200550660-Getting-Started',
  'What\'s New in PagerDuty': 'https://www.pagerduty.com/whats-new',
  'On-Call Readiness': '/responder-readiness',
};

export default key => (links[key] !== 'undefined' ? links[key] : false);
